var $c777dfa2ebd4aa1f$exports = {};
$c777dfa2ebd4aa1f$exports = {
    "valid": `Giltig`
};


export {$c777dfa2ebd4aa1f$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
